// https://next-auth.js.org/configuration/pages#oauth-sign-in
import Head from "next/head";

import HeaderLanding from "@components/Landing/Header";
import DefaultTags from "@components/DefaultTags";

// heavy design inspiration from https://tailwindcss.com/blog/2023-04-24-new-changelog-template-and-the-biggest-tailwind-ui-update-ever

function ChangelogPage() {
  const head = {
    title: "FixTheOps | Changelog",
    description: "Changelog page",
    image: "https://fixtheops.dev/fixtheops-logo/fixtheops-logo-bg-white.png",
    type: "website",
    url: "https://fixtheops.dev",
  };

  return (
    <>
      <Head>
        <DefaultTags />
        <title>{head.title}</title>
        <meta name="description" content={head.description}></meta>
        <link rel="canonical" href="https://fixtheops.dev" key="canonical" />
        <meta name="robots" content="all" key="robots" />

        {/* Open Graph */}
        <meta property="og:title" content={head.title} />
        <meta property="og:type" content={head.type} />
        <meta property="og:description" content={head.description} />
        <meta property="og:url" content={head.url} />
        <meta property="og:image" content={head.image} />

        {/* Twitter */}
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@fixtheops" />
        <meta name="twitter:title" content={head.title} />
        <meta name="twitter:description" content={head.description} />
        <meta name="twitter:image" content={head.image} />

        {/* <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" /> */}
        {/* <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" /> */}
        {/* <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" /> */}
        <link rel="manifest" href="/site.webmanifest" />

        <link
          rel="apple-touch-icon"
          sizes="57x57"
          href="/favicons/apple-icon-57x57.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="60x60"
          href="/favicons/apple-icon-60x60.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="72x72"
          href="/favicons/apple-icon-72x72.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="76x76"
          href="/favicons/apple-icon-76x76.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="114x114"
          href="/favicons/apple-icon-114x114.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="120x120"
          href="/favicons/apple-icon-120x120.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="144x144"
          href="/favicons/apple-icon-144x144.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="152x152"
          href="/favicons/apple-icon-152x152.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/favicons/apple-icon-180x180.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="192x192"
          href="/favicons/android-icon-192x192.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href="/favicons/favicon-32x32.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="96x96"
          href="/favicons/favicon-96x96.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href="/favicons/favicon-16x16.png"
        />
        <link rel="manifest" href="/favicons/manifest.json" />
        <meta name="msapplication-TileColor" content="#ffffff" />
        <meta name="msapplication-TileImage" content="/ms-icon-144x144.png" />
        <meta name="theme-color" content="#ffffff"></meta>
      </Head>

      <div className="landing">
        <HeaderLanding />

        <div className="px-4 sm:px-6 md:px-8 mt-8">
          <div className="max-w-2xl mx-auto">
            <main>
              <article className="mb-20">
                <div className="text-slate-700 mb-2">
                  <time dateTime="2023-12-21T08:00:00.000Z">
                    Thursday, December 21, 2023
                  </time>
                </div>
                <h2 className="text-2xl font-extrabold tracking-tight text-slate-900 md:text-3xl">
                  Kubernetes challenges are stopped
                </h2>
                <div className="mt-6 prose prose-slate">
                  I am sad to announce that the Kubernetes challenges are
                  stopped 😞. This is due to the fact that the infrastructure
                  costs were too high and my free time to work on this project
                  too scarce.
                  <br />I am grateful for all the feedback and support I
                  received from the community 💚
                </div>
                <hr className="mt-8" />
              </article>
              {/* <div className="relative mx-auto max-w-[37.5rem] pt-20 text-center pb-20">
              <h1 className="mb-4 px-10 font-bold leading-none tracking-tighter text-gray-900 text-4xl md:text-5xl max-w-screen-lg mx-auto">
                Changelog
              </h1>
            </div> */}
              {/* <div>WIP page 😅</div> */}
              <article className="mb-20">
                <div className="text-slate-700 mb-2">
                  <time dateTime="2023-11-29T08:00:00.000Z">
                    Wednesday, November 29, 2023
                  </time>
                </div>
                <h2 className="text-2xl font-extrabold tracking-tight text-slate-900 md:text-3xl">
                  New challenges & Solutions
                </h2>
                <div className="mt-6 prose prose-slate">
                  <b>3 news challenges</b> were added since the last update:
                  <ul>
                    <li>Standardise Kubernetes labels (very easy)</li>
                    <li>Hiding metrics - 1 (easy)</li>
                    <li>Payroll Panic: A Recovery Mission - 1 (medium)</li>
                  </ul>
                  ...and a new feature: <b>Solutions!</b> You can now write and
                  see solutions once you completed a challenge. This is a great
                  way to see how others might have solved the challenge
                  differently.
                  <br />
                  <br />
                  As a closing note, FixTheOps is looking for sponsors to help
                  cover the costs of running the platform. If you&apos;re
                  interested, please reach out to this{" "}
                  <a
                    href="mailto:hello@fixtheops.dev"
                    className="text-blue-500"
                  >
                    email address.
                  </a>
                </div>
                <hr className="mt-8" />
              </article>

              <article className="mb-20">
                <div className="text-slate-700 mb-2">
                  <time dateTime="2023-10-24T08:00:00.000Z">
                    Wednesday, October 24, 2023
                  </time>
                </div>
                <h2 className="text-2xl font-extrabold tracking-tight text-slate-900 md:text-3xl">
                  Alpha release! 🚀
                </h2>
                <div className="mt-6 prose prose-slate">
                  I am incredibly excited to announce the alpha release of
                  FixTheOps! After months of hard work, testing, refining,{" "}
                  <s>and a long summer break</s>, I&apos;m finally ready to open
                  up the platform!
                  <br />
                  <h3>What&rsquo;s new?</h3>
                  {/* <h3>What&apos;s New</h3> */}
                  <h4>Open Access for All Users 🌐 </h4>
                  No more waiting list! Starting today, anyone can log in to
                  FixTheOps using just a GitHub account and tackle the
                  challenges.
                  <br />
                  <h4>10 Challenges already 🔥</h4>
                  From begineer to intermediate level, I hope the first ones can
                  already provide some fun and learnings.
                  <br />
                  <h4>Leaderboard to compete against others 🏆</h4>
                  Climb the ladder, show off your points & connect to fellow
                  &ldquo;Ops/DevOps/Cloud/Whatever&rdquo; Engineers on the
                  Discord.
                  <br />
                  <br />
                  Looking forward to your feedback!
                </div>
                <hr className="mt-8" />
              </article>
            </main>
          </div>
        </div>
      </div>
    </>
  );
}

export default ChangelogPage;
